/**
 * Created by mark on 05/03/2018.
 */


import React  from 'react';
import Wizard from '../wizards/wizard.js';
import DuplicateComformation from '../wizards/assignments/library_step_one_fake.js';

export default class AssignmentWizard extends React.Component {

    constructor(props) {
        let Steps = [DuplicateComformation];
        super(props);
        this.state = {steps:Steps, names:undefined}
    }

    onModify(steps, names){
        this.setState({steps:steps, names:names});
    }

    render() {
        return <div>
            <Wizard information={{homeworkID:this.props.homeworkID, curriculumID:this.props.curriculumID, languageID:this.props.languageID}} onModify={this.onModify.bind(this)} names={this.state.names}  stepsNavigation={true} steps={this.state.steps} />
        </div>;
    }

}


